<template>
  <van-config-provider :theme-vars="themeVars">
    <div class="page_container">

      <div class="submit_title">评论回馈提交</div>
      <div class="submit_main_body">提交后我们会加急审核，请耐心等待</div>

      


      <van-form v-if="!submitSuccess"  class="submit_first_class_tilte" @submit="handleSubmit">
        <div
        style="margin-bottom: 0.2rem;"
        >评论所属的应用商店</div>
        <van-field
          v-model="fieldValue"
          name="appStore"
          is-link
          readonly
          placeholder="请选择应用所属应用商店"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择应用所属应用商店' }]"
          style="margin-bottom: 0.5rem;"
        />
        <van-popup v-model:show="showPicker" round position="bottom">
          <van-picker
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>

        <div style="margin-bottom: 0.1rem;">评论截图</div>
        <div style="margin-bottom: 0.5rem; color:#848488;">若无法弹出文件选择框或其他异常，请升级最新版本</div>

        <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
          <van-uploader
            v-model="fileList"
            accept="image/*"
            max-count="1"
            :after-read="afterRead"
            :before-delete="beforeDelete"
          />
        </div>

        <van-button
          type="primary"
          style="width:85%; margin-top:1rem;"
          native-type="submit"
        >提交</van-button>
      </van-form>
      
      <div v-if="submitSuccess" class="submit_first_class_tilte"
      
      >
        <div>提交成功</div>
        <div>感谢您的反馈</div>
        </div>
     

      
      
    </div>
  </van-config-provider>
</template>

<script setup>
import { ref } from 'vue';
import { showToast } from 'vant';
import {applyByPinglunhuikui } from '@/api/apiService'; // 你自己的上传地址获取方法

const columns = [
  { text: '苹果', value: '1' },
  { text: '小米', value: '2' },
  { text: 'oppo', value: '3' },
  { text: '华为', value: '4' },
  { text: 'vivo', value: '5' },
  { text: '应用宝', value: '6' },
  { text: '荣耀', value: '6' },
  { text: '其它', value: '7' }
];

const fieldValue = ref('');
const showPicker = ref(false);
var submitSuccess = ref(false);
const fileList = ref([]);

const onConfirm = ({ selectedOptions }) => {
  showPicker.value = false;
  fieldValue.value = selectedOptions[0].text;
};


function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function getDatePrefix() {
  const now = new Date();
  const pad = n => n.toString().padStart(2, '0');
  return (
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    pad(now.getHours()) +
    pad(now.getMinutes())
  );
}

// 手动上传逻辑
const afterRead = async (file) => {

  console.log('file', file);
};

// 可选：删除前确认
const beforeDelete = (file, detail) => {
  console.log('delete file', file, detail);
  fileList.value = [];
};

const isSubmitting = ref(false);
const handleSubmit = async () => {
  if (isSubmitting.value) {
    return; // 防止重复提交
  }
  isSubmitting.value = true;
  if (!fieldValue.value) {
    showToast('请选择应用所属应用商店');
    isSubmitting.value = false;
    return false;
  }
  if (!fileList.value.length) {
    showToast('请上传评论截图');
    isSubmitting.value = false;
    return false;
  }

// 文件大小校验
  const file = fileList.value[0];
  if (file.file.size > 2 * 1024 * 1024) {
    showToast('图片不能大于2M');
    isSubmitting.value = false;
    return false;
  }

  // 校验通过，执行提交逻辑
  try {
    // const file = fileList.value[0];
    const fileName = `${getDatePrefix()}-image-${uuidv4()}-${Date.now()}.${file.file.name.split('.').pop()}`;    // 获取上传地址（如OSS、S3等直传地址）
    const filePath = 'pinglunhuikui/' + fileName;
        console.log('filePath', filePath);


    //为后期多图片存储，保存到数组
      const filePathList = [filePath]

      // / 构建请求参数
      // const pinglunhuikuiRewardApply = {
      //   appStoreId: Number(columns.find(item => item.text === fieldValue.value)?.value),
      //   filePath: JSON.stringify(filePathList),
      // };


      const pinglunhuikuiRewardApply = new FormData();
      pinglunhuikuiRewardApply.append('appStoreId', Number(columns.find(item => item.text === fieldValue.value)?.value));
      pinglunhuikuiRewardApply.append('filePath', filePathList);
      pinglunhuikuiRewardApply.append('file', file.file);

      
      

      
      // 发送请求
      const result = await applyByPinglunhuikui(pinglunhuikuiRewardApply);

       console.log('result', result); // 只会显示 [object Object]
console.log('result (json):', JSON.stringify(result)); // 打印为字符串
console.log('result (展开):', result); // 控制台可点开查看


      if (result && result.code === 0) {
        showToast('提交成功！');
        // 可选：清空表单
        fieldValue.value = '';
        fileList.value = [];
        submitSuccess.value = true;
      } else if(result.code == 300){
        showToast("今日提交次数过多，联系管理员");
      }else{
        showToast("提交失败");
      }
      


    isSubmitting.value = false;

    
  } catch (e) {
    showToast('上传失败');
    isSubmitting.value = false;
    fileList.value = [];
  }
  return true;
};

const themeVars = {};
</script>

  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
  }

 

    
    
  .submit_title{
    font-size: 0.5rem;
    
    margin-bottom: 0.6rem;
    color: #0a0eeb;
    text-align: left;
    
  }
  .submit_main_body{
    font-size: 0.4rem;
    color:#848488;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-bottom: 0.2rem;
    
    text-align: left;
  }


  .submit_first_class_tilte{
    font-size: 0.4rem;
    color:#0606e6;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-top: 0.2rem;
    
    text-align: left;
  }







  </style>